import { render } from "./UsageTips.vue?vue&type=template&id=460417a2&scoped=true"
import script from "./UsageTips.vue?vue&type=script&lang=js"
export * from "./UsageTips.vue?vue&type=script&lang=js"

import "./UsageTips.vue?vue&type=style&index=0&id=460417a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460417a2"]])

export default __exports__